import { collection, onSnapshot, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from './firebaseConfig';
import './game.css';

function Scorecard() {
  const [guests, setGuests] = useState([])
  const [guestScores, setGuestScores] = useState([])
  const [questions, setQuestions] = useState([])

  useEffect(() => {
    function getGuestScore(guest) {
      var count = 0;

      if (Array.isArray(guest.answers) && guest.answers.length > 0) {
        questions.forEach(question => {
          guest.answers.forEach(answer => {
            if (question.id === answer.questionId) {
              try {
                const questionObject = JSON.parse(question.text)
                if (questionObject.correctAnswerId === answer.answerId) {
                  count++;
                }
              } catch {
                // Ignore malformed questions so the scoreboard can keep running.
              }
            }
          });
        });
      }

      return count;
    }

    var temp = [];

    guests.forEach((guest) => {
      const score = getGuestScore(guest);

      if (score > 0) {
        temp.push({
          guestName: guest.name || "Anonymous",
          score,
        });
      }
    });

    setGuestScores(temp.sort((a, b) => {

      if (a.score > b.score) {
        return -1;
      }
      if (a.score < b.score) {
        return 1;
      }

      // names must be equal
        return a.guestName.localeCompare(b.guestName);
    }));
    //console.log(temp)
  }, [guests, questions]);

  useEffect(() => {
    const questionCollection = collection(db, 'question');
    const questionsQuery = query(questionCollection);

    var unsub = onSnapshot(questionsQuery, (snapshot) => {
      const updatedQuestions = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setQuestions(updatedQuestions)
    });

    return () => unsub();

  }, []);


  useEffect(() => {

    const guestsCollection = collection(db, 'guest');
    //const guestsQuery = query(guestsCollection, where("answers", "!=", null));
    const guestsQuery = query(guestsCollection);

    // Subscribe to the guests collection for live updates
    const unsubscribe = onSnapshot(guestsQuery, (snapshot) => {
      const updatedGuests = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setGuests(updatedGuests)
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="scoreboard">
      <div className="scoreboard-header">
        <p className="game-kicker">50+ Desi Couples Trivia Night</p>
        <h1>Scoreboard</h1>
      </div>
      {guestScores.length === 0 && <p className="empty-state">Scores will appear as answers come in.</p>}
      {guestScores.length > 0 && <div className="podium-grid">
      {
        guestScores.slice(0, 3).map((guest, index)=>{
          return (
            <div className={`score-card podium-card rank-${index + 1}`} key={`${guest.guestName}-${index}`}>
              <div className="score-rank">{index === 0 ? '1st' : index === 1 ? '2nd' : '3rd'}</div>
              <div className="score-name">{guest.guestName}</div>
              <div className="score-value">{guest.score}</div>
            </div>

          )
        })
      }
      </div>}
      {guestScores.length > 3 && <div className="score-grid">
        {
          guestScores.slice(3).map((guest, index)=>{
            const rank = index + 4;
            return (
              <div className="score-card" key={`${guest.guestName}-${rank}`}>
                <div className="score-rank">#{rank}</div>
                <div className="score-name">{guest.guestName}</div>
                <div className="score-value">{guest.score}</div>
              </div>

            )
          })
        }
      </div>}
    </div>
  )
}

export default Scorecard
